<template>
  <div class="page">
    <div class="query-conditions">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <el-form-item>
          <el-input
            v-model="query.form.name"
            clearable
            placeholder="请输入姓名"
            @keyup.enter.native="handleFilter"
          />
        </el-form-item>

        <el-form-item>
          <el-cascader
            ref="category-cascader"
            v-model="query.form._departmentId"
            clearable
            :props="structureProps"
            :options="structure"
            :show-all-levels="false"
            placeholder="请选择组织架构"
          >
            <template slot-scope="{ node, data }">
              <span
                style="display:block;"
                @click="handleSelectCate(node, data)"
              >
                {{ data.name }}
              </span>
            </template>
          </el-cascader>
        </el-form-item>

        <el-form-item>
          <el-select
            v-model="query.form.role_id"
            clearable
            placeholder="请选择角色"
          >
            <el-option
              v-for="item in roles"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            plain
            type="primary"
            :loading="table.loading"
            @click="handleFilter"
          >
            查询
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="canaddUser"
            type="primary"
            @click="pushEdit('Add')"
          >
            添加
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div
      v-loading="table.loading"
      class="query-data"
    >
      <!-- list -->
      <el-table
        v-if="canuserList"
        stripe
        :data="table.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="ID"
          width="100"
        />
        <el-table-column
          prop="adv_user_id"
          label="ADV_ID"
          width="120"
        />
        <el-table-column
          prop="name"
          label="名称"
          width="120"
        />
        <el-table-column
          prop="pname_level"
          label="组织架构"
        />
        <el-table-column
          prop="is_leader"
          label="Leader"
          width="90"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.is_leader === '1'">是</div>
            <div v-else-if="scope.row.is_leader === '0'">否</div>
            <div v-else>未知</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="role"
          label="角色"
          width="200"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.roles.length > 0">
              <el-tag
                v-for="item in scope.row.roles"
                :key="item.name"
                type="success"
                style="margin: 6px"
              >
                {{ item.name }}
              </el-tag>
            </span>
            <el-tag
              v-else
              type="success"
            >
              {{ matchRoleText(scope.row.role_id) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="email"
          label="邮箱"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.email || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="200"
        >
          <template slot-scope="scope">
            <el-button
              v-if="canuserEdit"
              plain
              size="small"
              @click="pushEdit('Update', scope.row)"
            >
              编辑
            </el-button>
            <el-button
              v-if="canuserTransfer"
              plain
              size="small"
              @click="pushHandover(scope.row)"
            >
              交接
            </el-button>
            <!-- <el-button plain type="danger" size="small">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page.sync="query.form.page"
        :page-sizes="[10, 20, 30, 50]"
        layout="total, sizes, prev, pager, next"
        :total="table.total"
        style="margin-top: 30px; float: right"
        @size-change="handlePageSizeChange"
        @current-change="handleQueryPage"
      />
    </div>

    <!-- edit -->
    <form-dialog
      :visible.sync="editForm.display"
      :title="(editForm.type === 'Add' ? '添加' : '编辑') + '用户'"
      :loading="editForm.loading"
      width="600px"
      @close="handleFormClose"
      @submit="submitEditFormAction"
    >
      <el-form
        ref="editForm"
        :model="editForm.form"
        :rules="editForm.rules"
        label-width="100px"
      >
        <el-form-item
          v-show="editForm.type !== 'Add'"
          label="ID"
        >
          <el-input
            v-model="editForm.form.id"
            disabled
          />
        </el-form-item>
        <el-form-item
          label="姓名"
          prop="name"
        >
          <el-input
            v-model="editForm.form.name"
            placeholder="请输入姓名"
          />
        </el-form-item>
        <el-form-item
          label="邮箱"
          prop="email"
        >
          <el-input
            v-model="editForm.form.email"
            placeholder="请输入邮箱"
          />
        </el-form-item>
        <el-form-item label="Leader">
          <el-switch
            v-model="editForm.form._isLeader"
            active-text="是"
            inactive-text="否"
          />
        </el-form-item>
        <el-form-item
          label="组织架构"
          prop="_departmentId"
        >
          <el-cascader
            ref="dialog-category-cascader"
            v-model="editForm.form._departmentId"
            clearable
            :props="structureProps"
            :options="structure"
            :show-all-levels="false"
            placeholder="请选择组织架构"
          >
            <template slot-scope="{ node, data }">
              <span
                style="display:block;"
                @click="handleDialogSelectCate(node, data)"
              >
                {{
                  data.name
                }}
              </span>
            </template>
          </el-cascader>
        </el-form-item>
        <el-form-item
          label="角色"
          prop="role_id"
        >
          <el-select
            v-model="editForm.form.role_id"
            placeholder="请选择角色"
            multiple
          >
            <el-option
              v-for="item in roles"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <template v-if="editForm.form.role_id.includes('2')">
          <el-form-item
            label="上级"
            prop="p_id"
          >
            <el-select
              v-model="editForm.form.p_id"
              placeholder="输入上级"
              style="width: 100%;"
              clearable
              filterable
              remote
              collapse-tags
              reserve-keyword
              :remote-method="handleSearchLeader"
            >
              <el-option
                v-for="item in leaderOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </template>
      </el-form>
    </form-dialog>

    <!-- handover -->
    <form-dialog
      :visible.sync="handoverForm.display"
      title="工作交接"
      :loading="handoverForm.loading"
      width="30%"
      @submit="submitHandoverFormAction"
    >
      <el-form
        ref="handoverForm"
        :model="handoverForm.form"
        :rules="handoverForm.rules"
        label-width="100px"
      >
        <el-form-item
          label="移交人"
          prop="_oldName"
        >
          <el-input
            v-model="handoverForm.form._oldName"
            style="width: 70%"
            disabled
            placeholder="请输入移交人"
          />
        </el-form-item>
        <el-form-item
          label="接交人"
          prop="_newName"
        >
          <el-autocomplete
            v-model="handoverForm.form._newName"
            style="width: 70%"
            :fetch-suggestions="querySearchUser"
            placeholder="请选择接交人"
            @select="handleSelectUser"
          >
            <template slot-scope="{ item }">
              {{ item.name || '' }}
            </template>
          </el-autocomplete>
        </el-form-item>
      </el-form>
    </form-dialog>
  </div>
</template>

<script>
import Request from '@/core/QuRequest';
import { FormDialog } from '@/components';

const req = new Request();

export default {
  name: 'SysManageUser',
  components: { FormDialog },
  data() {
    return {
      leaderOptions: [],
      structureProps: {
        value: 'id',
        label: 'name',
        children: 'child',
        checkStrictly: true,
        expandTrigger: 'hover',
      },
      structure: [], // 组织架构列表
      roles: [], // 角色列表
      table: {
        list: [],
        total: 0,
        loading: false,
      },
      query: {
        form: {
          name: '',
          page: 1,
          page_size: 10,
          _departmentId: [], // form 数据
          role_id: '',
        },
      },
      editForm: {
        display: false,
        loading: false,
        type: 'Add',
        form: {
          id: '',
          name: '',
          email: '',
          _departmentId: [], // form 数据
          department_id: '',
          role_id: '',
          _isLeader: false,
          is_leader: 0,
        },
        rules: {
          _departmentId: [
            {
              required: true,
              message: '组织架构必选',
              type: 'array',
              triggle: 'change',
            },
          ],
          name: [
            {
              required: true,
              message: '姓名必填',
              type: 'string',
              triggle: 'blur',
            },
          ],
          email: [
            { required: true, message: '邮箱必填', triggle: 'blur' },
            {
              pattern: /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@([a-zA-Z0-9]+[-.])+[a-zA-Z0-9]{2,}$/,
              message: '输入正确的邮箱',
              triggle: 'blur',
            },
          ],
          role_id: [{ required: true, message: '角色必选', trigger: 'change' }],
        },
      },
      handoverForm: {
        display: false,
        loading: false,
        form: {
          old_id: '',
          _oldName: '',
          _newName: '',
          _newOne: {},
        },
        rules: {
          _oldName: [
            { required: true, message: '移交人必选', triggle: 'blur' },
          ],
          _newName: [
            {
              required: true,
              validator: (rule, value, callback) => {
                if (value === '') {
                  callback(new Error('接交人必选'));
                } else if (
                  this.handoverForm.form._newName !==
                  this.handoverForm.form._newOne.name
                ) {
                  callback(new Error('未匹配到接交人'));
                } else {
                  callback();
                }
              },
              triggle: 'change',
            },
          ],
        },
      },
    };
  },
  computed: {
    perms() {
      return this.$store.state.perms;
    },

    canuserList() {
      return this.perms.includes('userList');
    },

    canuserEdit() {
      return this.perms.includes('userEdit');
    },

    canuserTransfer() {
      return this.perms.includes('userTransfer');
    },

    canaddUser() {
      return this.perms.includes('addUser');
    },
  },
  created() {
    this._getList();
    this._getRoleList();
    this._getStructureList();
  },
  methods: {
    async handleSearchLeader(val){
      const res = await req.send(req.Apis.customer.productSeries.sales, {
        is_budget:3, 
        name: val,
        page: 1,
        page_size: 100,
      });
      if(res.code === 200) {
        const {data} = res;
        this.leaderOptions = (data.data || []).map(item => {
          return {label: item.name, value: item.id}
        })
      }
    },
    // 获取角色数据
    async _getRoleList() {
      try {
        const res = await req.send(req.Apis.sales.user.getRoleList);
        this.roles = [...(res.data || [])];
      } catch (err) {
        this.$message.error(`获取角色失败：${err.message || '未知错误'}`);
      }
    },

    // 获取组织架构数据
    async _getStructureList() {
      try {
        const res = await req.send(req.Apis.sales.user.structure);
        // this.structure = (res.data || {}).id ? [{ ...(res.data || {}) }] : [];
        this.structure = addLeafOption(res.data);
      } catch (err) {
        this.$message.error(`获取组织架构失败：${err.message || '未知错误'}`);
      }
    },

    // 获取用户列表数据
    async _getList() {
      try {
        let _query = this.query.form;
        const params = {
          page: _query.page,
          page_size: _query.page_size,
        };

        // 组织架构
        let departmentId = '';
        const sLen = this.query.form._departmentId.length;
        if (sLen > 0) {
          // 最后一个ID
          departmentId = this.query.form._departmentId[sLen - 1];
        }

        !!_query.name && (params.name = _query.name);
        !!departmentId && (params.department_id = departmentId);
        !!_query.role_id && (params.role_id = _query.role_id);

        this.table.loading = true;
        // req
        const res = await req
          .send(req.Apis.sales.user.getUserList, params)
          .fin(() => {
            this.table.loading = false;
          });
        const dv = res.data || {};
        this.table.list = [...(dv.data || [])];
        this.table.total = Number(dv.total || 0);
      } catch (err) {
        this.$message.error(`获取用户列表失败：${err.message || '未知错误'}`);
      }
    },

    // async 添加/编辑
    async processEdit() {
      try {
        this.editForm.loading = true;

        // 组织架构
        let departmentId = '';
        const sLen = this.editForm.form._departmentId.length;
        if (sLen > 0) {
          // 最后一个ID
          departmentId = this.editForm.form._departmentId[sLen - 1];
        }

        const params = {
          ...this.editForm.form,
          role_ids: this.editForm.form.role_id,
          department_id: departmentId,
          is_leader: this.editForm.form._isLeader ? 1 : 0,
        };
        delete params.role_id;
        const api =
          req.Apis.sales.user[
            this.editForm.type === 'Add' ? 'addUser' : 'editUser'
          ];
        await req.send(api, params).fin(() => {
          this.editForm.loading = false;
        });

        this._getList(); // 刷新列表
        this.editForm.display = false;
      } catch (err) {
        this.editForm.loading = false;
        this.$message.error(`编辑失败：${err.message || '未知错误'}`);
      }
    },

    // async 交接
    async processHandover() {
      try {
        this.handoverForm.loading = true;
        const params = {
          old_id: this.handoverForm.form.old_id,
          new_id: this.handoverForm.form._newOne.id,
        };
        await req.send(req.Apis.sales.user.userTransfer, params).fin(() => {
          this.handoverForm.loading = false;
        });
        this.$message.success('交接请求成功');
        this._getList();
        this.handoverForm.display = false;
      } catch (err) {
        this.$message.error(`请求失败：${err.message || '未知错误'}`);
      }
    },

    handleSelectCate(node) {
      const panel = this.$refs['category-cascader'].panel;
      panel.handleCheckChange(node.path);
      panel.handleExpand(node);
    },

    handleDialogSelectCate(node) {
      const panel = this.$refs['dialog-category-cascader'].panel;
      panel.handleCheckChange(node.path);
      panel.handleExpand(node);
    },

    // 搜索查询
    querySearchUser(keyword, cb) {
      clearTimeout(this.querySearch);
      this.querySearch = setTimeout(() => {
        req
          .send(req.Apis.sales.user.getUserList, {
            name: keyword,
            page: 1,
            page_size: 50,
          })
          .then((res) => {
            // reset
            const list = (res.data || {}).data || [];
            if (list.length <= 0) {
              this.handoverForm.form._newOne = {};
            }
            cb(list);
          });
      }, 100);
    },

    // 选择
    handleSelectUser(item) {
      this.handoverForm.form._newOne = item || {};
      this.$nextTick(() => {
        this.handoverForm.form._newName = item.name;
      });
    },

    // 关闭form弹窗时重置一下校验，不要让上一个form的校验提示保留到下一个弹窗
    handleFormClose() {
      this.$refs.editForm.resetFields();
    },

    // 筛选
    handleFilter() {
      this.query.form.page = 1;
      this._getList();
    },

    // 页量改变
    handlePageSizeChange(pageSize) {
      this.query.form.page_size = Number(pageSize);
      this._getList();
    },

    // 页码改变
    handleQueryPage(page) {
      this.query.form.page = Number(page);
      this._getList();
    },

    // 编辑弹窗
    // eslint-disable-next-line camelcase
    pushEdit(
      type = 'Add',
      { id, name, email, pid_level, role_id, is_leader, roles, p_id, p_name } = {},
    ) {
      this.editForm.type = type || 'Add';
      this.editForm.form = {
        id,
        name,
        email,
        // eslint-disable-next-line camelcase
        _departmentId: type === 'Add' ? [] : pid_level.split(',') || [],
        // eslint-disable-next-line camelcase
        _isLeader: !!Number(is_leader),
        is_leader,
        role_id: roles ? roles.map((item) => item.id) : [],
        p_id,
      };
      this.editForm.display = true;
      if(p_name) {
        this.handleSearchLeader(p_name)
      }
    },

    // 交接弹窗
    pushHandover(item = {}) {
      this.handoverForm.form = {
        old_id: item.id,
        _oldName: item.name,
        _newName: '',
        _newOne: {},
      };
      this.handoverForm.display = true;
    },

    // 提交编辑
    submitEditFormAction() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          this.processEdit();
        } else {
          return false;
        }
      });
    },

    // 交接
    submitHandoverFormAction() {
      this.$refs['handoverForm'].validate((valid) => {
        if (valid) {
          this.processHandover();
        } else {
          return false;
        }
      });
    },

    // 匹配role
    matchRoleText(roleId = '') {
      return (
        (this.roles.find((role) => Number(role.id) === Number(roleId)) || {})
          .name || '--'
      );
    },
  },
};

/**
 * 递归 如果是叶节点，不需要child属性，直接删除
 */
function addLeafOption(ori = []) {
  return ori.map((i) => {
    if (i.child && i.child.length === 0) {
      delete i.child;
      return i;
    } else {
      i.child = addLeafOption(i.child);
      return i;
    }
  });
}
</script>

<style lang="less" scoped>
.query-data {
  // table
  .query-table {
    position: relative;
    overflow: hidden;
  }
}
</style>
